import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '../common/App';
const rootEl = document.querySelector('#parish-map-root');
if (rootEl) {
  const root = createRoot(rootEl);
  root.render( /*#__PURE__*/React.createElement(App, null));
} else {
  throw new Error(`Can't find the react root!`);
}